import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginSchema } from "../../utils/validationSchema";
import LoadingButton from "@mui/lab/LoadingButton";
import { FaEye, FaEyeSlash, FaUserCircle } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { loginApi } from "../../app/slices/loginSlice";
import LoginQR from "../../components/LoginQR";
import { loginApi2 } from "../../app/slices/loginSlice2";
import axiosInstance from "../../utils/axiosInstance";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const [showPassword, setShowPassword] = useState(false);
  const [email, setemail] = useState("");
  const [showForgotForm, setshowForgotForm] = useState(true);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [showLoginQR, setShowLoginQR] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [qrData, setQrdata] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const {
    values,
    handleSubmit,
    handleBlur,
    errors,
    handleChange,
    isSubmitting,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const response = await dispatch(loginApi(values)).unwrap();
        // console.log("res==========>>>", response)

        if (response.error) {
          Swal.fire({
            icon: "error",
            text: response.message || "An error occurred. Please try again.",
          });
        }
        if (!response.mfa) {
          setQrdata(response.qrCode);
          setShowLoginQR(true);
        } else {
          setShowOtp(true);
        }
      } catch (error) {
        console.error("ERROR IN CATCH=========>###>>", error);
        Swal.fire({
          icon: "error",
          text:
            error?.message ||
            error.response.data.message ||
            "An error occurred. Please try again.",
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleShowForm = (e) => {
    e.preventDefault();
    setshowForgotForm(!showForgotForm);
  };
  const forgotPasswordApi = async (e) => {
    e.preventDefault();
    try {
      const url = `/forgot_password`;
      // const url = `${baseUrl}/forgot_password`;
      const response = await axiosInstance.post(url, { email });
      // const response = await axios.post(url, { email });
      if (response.data.message == "Email sent successfully") {
        // toast.success("Email sent successfully, please check your Email");
        await Swal.fire({
          icon: "success",
          title: response?.data?.message || "Email sent successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("Error connecting to API", error);
      // toast.error(error.response.data.message);
      await Swal.fire({
        icon: "error",
        title: error?.response?.data?.message || "Something went wrong",
        text: "An error occurred. Please try again.",
      });
      // console.log("error.response.data.message: ", error.response.data.message);
    }
  };

  const [loading, setLoading] = useState(false);
  const handleSubmintOTP = async () => {
    const enableMfaUrl = `/admin_panel/mfa/enable`;
    const loginMfaUrl = `/admin_panel/loginwithmfa`;
    // const enableMfaUrl = `${import.meta.env.VITE_MAIN_URL}/admin_panel/mfa/enable`;
    // const loginMfaUrl = `${import.meta.env.VITE_MAIN_URL}/admin_panel/loginwithmfa`;

    const mfaToken = otp.join("");

    if (mfaToken.length !== 6) {
      Swal.fire({
        icon: "warning",
        text: "Please enter a valid 6-digit OTP",
      });
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...values,
        mfa_token: mfaToken,
      };

      const response = await dispatch(
        loginApi2({
          url: qrData ? enableMfaUrl : loginMfaUrl,
          values: payload,
        }),
      ).unwrap();

      const { token, message } = response;

      if (token) {
        localStorage.setItem("token", token);
      }

      Swal.fire({
        icon: "success",
        text: message || "Login Successful!",
        showConfirmButton: false,
        timer: 1500,
      });

      navigate("/");
    } catch (error) {
      Swal.fire({
        icon: "error",
        text:
          error?.message ||
          error?.response?.data?.message ||
          "OTP verification failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center text-gray-600 bg-gray-50">
      {/*  */}

      <LoginQR
        showLoginQR={showLoginQR}
        qrData={qrData}
        setOtp={setOtp}
        otp={otp}
        handleSubmintOTP={handleSubmintOTP}
        showOtp={showOtp}
        loading={loading}
      />

      {!showOtp && !showLoginQR && (
        <div className="relative flex flex-col sm:w-[30rem] rounded-lg border-gray-400 bg-white shadow-lg px-4">
          <div className="flex-auto p-6">
            <div className="mb-5 flex flex-shrink-0 flex-grow-0 items-center justify-center overflow-hidden">
              <a
                href="#"
                className="flex cursor-pointer items-center gap-2 text-indigo-500 no-underline hover:text-indigo-500"
              >
                <span className="flex-shrink-0 text-4xl font-black tracking-tight opacity-100 flex items-center">
                  <img
                    src="./img/batukSmallLogo.png"
                    alt="batukLogo"
                    width={70}
                  />
                  BATUK
                </span>
              </a>
            </div>
            <h4 className="mb-2 font-medium text-gray-700 xl:text-xl">
              Welcome to Batuk!
            </h4>
            {showForgotForm && (
              <>
                <p className="mb-6 text-gray-500">
                  Please sign in to access your account
                </p>
                <form className="mb-4" onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <FormControl
                      size="small"
                      fullWidth
                      variant="outlined"
                      error={!!errors.email}
                      required
                    >
                      <InputLabel
                        htmlFor="email"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      >
                        Email
                      </InputLabel>
                      <OutlinedInput
                        id="email"
                        type="text"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <FaUserCircle />
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Email"
                      />
                      <FormHelperText>
                        {errors.email ? errors.email : " "}
                      </FormHelperText>
                    </FormControl>
                  </div>

                  <div className="mb-4">
                    <FormControl
                      size="small"
                      fullWidth
                      variant="outlined"
                      error={!!errors.password}
                      required
                    >
                      <InputLabel
                        htmlFor="password"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      >
                        Password
                      </InputLabel>
                      <OutlinedInput
                        id="password"
                        type={showPassword ? "text" : "password"}
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                      />
                      <FormHelperText>
                        {errors.password
                          ? errors.password
                          : "Password must be at least 6 characters long."}
                      </FormHelperText>
                    </FormControl>
                  </div>
                  <div className="mb-4">
                    <LoadingButton
                      type="submit"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                      variant={isSubmitting ? "outlined" : "contained"}
                      fullWidth
                    >
                      <span>SIGN IN</span>
                    </LoadingButton>
                  </div>
                </form>
              </>
            )}
            {!showForgotForm && (
              <>
                <p className="mb-6 text-gray-500">
                  Please enter your registered Email
                </p>
                <form className="mb-4">
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Email"
                        size="small"
                        type="text"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setemail(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        //   sx={{mt:"1rem"}}
                        onClick={forgotPasswordApi}
                      >
                        Send Email
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </>
            )}

            <Button
              sx={{
                color: "red",
                fontStyle: "italic",
                float: "right",
                textTransform: "none",
              }}
              onClick={handleShowForm}
            >
              {showForgotForm ? "forgot password ?" : "Sign in"}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
